import { Component, Input } from '@angular/core';
import { FileOrImageSelectorComponent } from '../../base/file-or-image-selector.component';
import { TvlImage } from '../../models/image.model';

@Component({
    selector: 'tvcore-image-selector',
    templateUrl: './image-selector.component.html',
    styleUrls: ['./image-selector.component.scss'],
    standalone: false
})
export class ImageSelectorComponent extends FileOrImageSelectorComponent<TvlImage> {
	@Input()
	disabled: boolean = false;
	@Input()
	primary: boolean = false;

	getUrl(image: TvlImage, rel: string = '320x320'): string {
		const link = image.links.find((l) => l.rel === rel);

		if (link) {
			return link.href;
		}

		return image.links[0].href;
	}

	override get currentFiles(): TvlImage[] {
		return super.currentFiles.filter((image) => (this.primary ? image.primary : !image.primary)); // TODO: filter primary ?
	}
}
